module.exports = __webpack_public_path__ + "img/report.2d9d1468.svg";